import React, { useState, useRef, useEffect } from 'react';
import logo from './assets/axie-logo.png';
import WalletModal from './components/WalletModal'; // import modal

export default function Navbar({ onLoginClick, user }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [walletOpen, setWalletOpen] = useState(false); // trạng thái mở ví
  const dropdownRef = useRef(null);
  const [history, setHistory] = useState([]);

  // Đóng dropdown khi click ngoài
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Lấy lịch sử điểm khi mở WalletModal
  useEffect(() => {
    if (walletOpen && user) {
      fetch(`https://api.dsuni8386.com/history/${user.id}`)
        .then(res => res.json())
        .then(data => setHistory(data))
        .catch(() => setHistory([]));
    }
  }, [walletOpen, user]);

  return (
    <>
      <nav className="fixed top-0 left-0 w-full z-50 bg-gradient-to-b from-black/60 via-black/30 to-transparent flex items-center justify-between px-10 py-4">
        <div>
          <img src={logo} alt="Axie Infinity" className="h-20 md:h-40 w-auto" />
        </div>
        <div className="hidden md:flex space-x-20 text-white font-bold text-xl uppercase tracking-wider">
          <button
            onClick={() => {/* xử lý navigation nếu cần */}}
            className="hover:text-yellow-400 bg-transparent border-none cursor-pointer"
          >
            Games
          </button>
          <button
            onClick={() => {/* xử lý navigation nếu cần */}}
            className="hover:text-yellow-400 bg-transparent border-none cursor-pointer"
          >
            Marketplace
          </button>
          <button
            onClick={() => {/* xử lý navigation nếu cần */}}
            className="hover:text-yellow-400 bg-transparent border-none cursor-pointer"
          >
            Idols Ranking
          </button>
          <button
            onClick={() => {/* xử lý navigation nếu cần */}}
            className="hover:text-yellow-400 bg-transparent border-none cursor-pointer"
          >
            DS.GROUP
          </button>
          <button
            onClick={() => {/* xử lý navigation nếu cần */}}
            className="hover:text-yellow-400 bg-transparent border-none cursor-pointer"
          >
            Social
          </button>
          <button
            onClick={() => {/* xử lý navigation nếu cần */}}
            className="hover:text-yellow-400 bg-transparent border-none cursor-pointer"
          >
            More
          </button>
        </div>
        <div className="relative">
          {user ? (
            <>
              <img
                src={user.avatar || 'https://via.placeholder.com/40'}
                alt={user.id}
                className="h-10 w-10 rounded-full cursor-pointer border-2 border-yellow-400"
                onClick={() => setDropdownOpen(!dropdownOpen)}
                title={user.id}
              />
              {dropdownOpen && (
                <div
                  ref={dropdownRef}
                  className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-2 z-50"
                >
                  <div className="px-4 py-2 text-gray-800 font-semibold border-b">
                    {user.id}
                  </div>
                  <button
                    onClick={() => {
                      setWalletOpen(true);
                      setDropdownOpen(false);
                    }}
                    className="flex justify-between items-center px-4 py-2 text-gray-700 hover:bg-yellow-400 hover:text-black w-full text-left"
                  >
                    <span>Ví</span>
                    <span className="bg-yellow-400 text-black rounded-full px-2 py-0.5 text-sm font-bold">
                      {user.points ?? 0} ⭐
                    </span>
                  </button>
                  <button
                    onClick={() => {
                      // xử lý Hỗ trợ
                    }}
                    className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-yellow-400 hover:text-black cursor-pointer"
                  >
                    Hỗ trợ
                  </button>
                  <button
                    onClick={() => {
                      // xử lý Cài đặt
                    }}
                    className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-yellow-400 hover:text-black cursor-pointer"
                  >
                    Cài đặt
                  </button>
                  <button
                    className="w-full text-left px-4 py-2 text-red-600 hover:bg-red-100 cursor-pointer"
                    onClick={() => {
                      window.location.reload();
                    }}
                  >
                    Đăng xuất
                  </button>
                </div>
              )}
            </>
          ) : (
            <button
              onClick={onLoginClick}
              className="bg-white/10 text-white font-extrabold px-6 py-2 rounded-lg border border-white/20 hover:bg-yellow-400 hover:text-black transition"
            >
              LOG IN
            </button>
          )}
        </div>
      </nav>
      {/* Modal Ví */}
      {walletOpen && (
        <WalletModal
          onClose={() => setWalletOpen(false)}
          points={user?.points}
          history={history}
        />
      )}
    </>
  );
}
